// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Import Helper
import { CheckIfFlowUpdated } from "../../../../helpers/helper";

// Import Recoil
import { changedFields, initialActions, saveAvailable } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import FieldLabel from "../../../FlowConfigurationInputs/FieldLabel/FieldLabel";
import {MenuItem, Select} from "@material-ui/core";
import {PasswordInput} from "../../../FlowConfigurationInputs/PasswordInput/NewPasswordInput";
import {TextInput} from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";


function JWTDecode({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.CRYPTOGRAPHY.JWT-DECODE.';
    const [algorithmType, setAlgorithmType] = useState('HMAC');

    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    useEffect(() => {
        if (!action.fields.algorithmType) {
            action.fields.algorithmType = { value: 'HMAC', isRequired: false };
        } else {
            setAlgorithmType(action.fields.algorithmType.value);
        }
    }, [action]);

    const handleAlgorithmChange = (e) => {
        const value = e.target.value;

        const field = initialActionsData[action.id]?.fields.algorithmType;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('algorithmType', action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);

        action.fields.algorithmType.value = value;
        setAlgorithmType(value);
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'JWT-ALGORITHM')} is_required/>
                <Select value={algorithmType} onChange={handleAlgorithmChange} variant="outlined" fullWidth
                        style={{width: "90%"}} isRequired={true}>
                    <MenuItem value="HMAC">HMAC</MenuItem>
                    {/*<MenuItem value="RSA">RSA</MenuItem>*/}
                    {/*<MenuItem value="ECDSA">ECDSA</MenuItem>*/}
                </Select>
            </div>
            {
                algorithmType.includes("HMAC") && (
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + "HMAC-SECRET")} is_required/>

                        <PasswordInput action={action} inputName="secret" variables={variables}
                                       setOpenVariable={setOpenVariable} isRequired={true}
                                       displayName={t(label + 'HMAC-SECRET')} hideRequired={true}
                                       isPassword={true}/>
                    </div>
                )
            }

            <div className="conf-field-container">
                <FieldLabel name={t(label + "JWT-TOKEN")} is_required/>
                <PasswordInput action={action} inputName="token" variables={variables}
                               setOpenVariable={setOpenVariable} isRequired={true}
                               displayName={t(label + 'JWT-TOKEN')} hideRequired={true}
                               isPassword={true}/>
            </div>

            <div className='conf-field-container'>
                <FieldLabel name={t(label + 'ASSIGN-TOKEN')} is_required/>
                <VariablePicker
                    action={action}
                    setOpenVariable={setOpenVariable}
                    variables={variables}
                    inputName="set"
                    isRequired={true}
                    hideRequired
                    filter="object"
                />
                <small
                    className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', {type: 'object'})}</em></small>
            </div>
        </div>
    )
}

export default JWTDecode;